import axios from 'axios';

//  const baseURL = 'http://127.0.0.1:5000/';
const baseURL = 'https://api-documentos.bairru.com.br';

const apiDocumentos = axios.create({ baseURL });

export default apiDocumentos;
